import { z } from "zod";

import { parseManuscript, type Manuscript } from "./manuscript.ts";
import {
  builtInTemplates,
  conservativeSciTemplate,
  parseTemplate,
  type ManuscriptTemplate,
} from "./templates.ts";

export type SavedWorkspace = {
  manuscript: Manuscript;
  customTemplates: ManuscriptTemplate[];
};

export function createWorkspaceFingerprint(
  manuscript: Manuscript,
  template: ManuscriptTemplate,
): string {
  return JSON.stringify({ manuscript, template });
}

export function isWorkspaceExportCurrent(
  requestFingerprint: string,
  currentFingerprint: string,
): boolean {
  return requestFingerprint === currentFingerprint;
}

const workspaceEnvelopeSchema = z.object({
  manuscript: z.unknown(),
  customTemplates: z.array(z.unknown()).max(100),
});

export function parseSavedWorkspace(value: unknown): SavedWorkspace {
  const envelope = workspaceEnvelopeSchema.parse(value);
  const manuscript = parseManuscript(envelope.manuscript);
  const reservedIds = new Set(builtInTemplates.map((template) => template.id));
  const customTemplates = envelope.customTemplates.map((value) => {
    const template = parseTemplate(value, { forceDraft: true });
    if (reservedIds.has(template.id)) {
      throw new Error(`模板标识符重复：${template.id}`);
    }
    reservedIds.add(template.id);
    return template;
  });

  return {
    manuscript: {
      ...manuscript,
      templateId: reservedIds.has(manuscript.templateId)
        ? manuscript.templateId
        : conservativeSciTemplate.id,
    },
    customTemplates,
  };
}
